import { getPersonalizedSearchPageRoute } from 'site-modules/shared/utils/personalized-search/personalized-search-utils';
import { SEARCH_QUERY_PARAM } from 'site-modules/shared/constants/personalized-search/personalized-search';

export const getPersonalizedSearchLinkUrl = query =>
  `${getPersonalizedSearchPageRoute()}?${SEARCH_QUERY_PARAM}=${encodeURIComponent(query)}`;
